<template>
  <f7-popup
    class="popup-planif-abiertas"
    :opened="opened"
    :close-by-backdrop-click="false"
    @popup:closed="$emit('cerrado')"
  >
    <f7-page :page-content="true">
      <f7-navbar :title="'El pedido tiene planificaciones abiertas'">
        <f7-nav-right>
          <f7-link @click="$emit('cancelar')">Cerrar</f7-link>
        </f7-nav-right>
      </f7-navbar>
      <f7-page-content>

        <f7-block strong class="pa-intro">
          <p>
            Vas a <strong>{{ textoAccion }}</strong> el pedido
            <strong>{{ codigoPedido }}</strong>, pero
            {{ planificaciones.length === 1
              ? 'tiene una planificación abierta en el calendario'
              : 'tiene ' + planificaciones.length + ' planificaciones abiertas en el calendario' }}.
          </p>
          <p>
            Mientras sigan ahí, el calendario seguirá contándolas en el OEB y el reparto de
            ejecución ya no las contará: es lo que produce el descuadre. Lo que hay que hacer es
            desplanificarlas, o moverlas al pedido que sustituye a este, desde el calendario.
          </p>
          <p class="pa-nota">
            El sistema no desplanifica ni mueve nada por su cuenta: la corrección la haces tú en el
            calendario y queda allí con tu usuario.
          </p>
        </f7-block>

        <f7-list media-list class="pa-lista">
          <f7-list-item
            v-for="(planificacion, indice) in planificaciones"
            :key="planificacion.idPlanificacion || indice"
          >
            <div slot="title" class="pa-fila-titulo">
              {{ nombrarPersonas(planificacion) }}
            </div>
            <div slot="subtitle">
              {{ formatearFecha(planificacion.fecha) }} &middot;
              Línea {{ planificacion.numLinea != null ? planificacion.numLinea : '?' }}
              <template v-if="planificacion.descripcionLinea">
                ({{ planificacion.descripcionLinea }})
              </template>
            </div>
            <div slot="text" class="pa-estado">
              {{ textoEstado(planificacion) }}
            </div>
            <div slot="footer" class="pa-acciones">
              <!-- Un punto de entrada solo se dibuja si la pantalla es alcanzable (CLAUDE.md §9):
                   manda el MENÚ efectivo del usuario, no su rol, así que esto se pregunta a
                   `puedeAbrirCalendario` y no a una lista de roles escrita aquí. -->
              <template v-for="persona in personasDe(planificacion)">
                <f7-button
                  v-if="puedeAbrirCalendario(persona.username)"
                  :key="'ir-' + (planificacion.idPlanificacion || indice) + '-' + persona.username"
                  class="pa-boton-ir"
                  small
                  outline
                  @click="irAlCalendario(persona.username, planificacion.fecha)"
                >Ir al calendario de {{ persona.nombre || persona.username }}</f7-button>
                <div
                  v-else
                  :key="'no-' + (planificacion.idPlanificacion || indice) + '-' + persona.username"
                  class="pa-sin-acceso"
                >
                  No puedes abrir el calendario de {{ persona.nombre || persona.username }}: no
                  tienes Calendario en tu menú. Esta planificación la tiene que desplanificar
                  {{ persona.nombre || persona.username }}, o quien lleve la planificación, desde
                  Calendario &rsaquo; {{ persona.nombre || persona.username }}. Pídeselo antes de
                  continuar.
                </div>
              </template>
              <div v-if="!personasDe(planificacion).length" class="pa-sin-acceso">
                Esta planificación no tiene inspector asignado, así que no hay un calendario al que
                ir. La tiene que revisar quien lleve la planificación.
              </div>
            </div>
          </f7-list-item>
        </f7-list>

        <f7-list class="pa-motivo">
          <f7-list-input
            type="textarea"
            label="Motivo para continuar igualmente"
            placeholder="Por qué se sigue adelante dejando estas planificaciones"
            :maxlength="limiteMotivo"
            :info="infoMotivo"
            :value="motivo"
            @input="motivo = ($event.target.value || '')"
          ></f7-list-input>
        </f7-list>

        <f7-block class="pa-salidas">
          <f7-button
            class="pa-boton-continuar"
            fill
            color="red"
            :disabled="!motivoValido"
            @click="continuar"
          >Continuar y {{ textoAccion }} igualmente</f7-button>
          <!-- Un control deshabilitado dice por qué, quién lo desbloquea y dónde, y lo dice JUNTO
               al control, no en un aviso al principio de la pantalla (CLAUDE.md §9). -->
          <div v-if="!motivoValido" class="pa-explicacion-bloqueo">
            Para poder continuar escribe antes el motivo en el campo de arriba: lo desbloqueas tú
            mismo escribiéndolo, y queda en el histórico del pedido con tu usuario y la fecha.
          </div>
          <f7-button class="pa-boton-volver" @click="$emit('cancelar')">
            No {{ textoAccion }} el pedido
          </f7-button>
        </f7-block>

      </f7-page-content>
    </f7-page>
  </f7-popup>
</template>

<style scoped>
/* El tope del ancho va DENTRO de la variable, no en un `max-width` aparte: F7 centra el popup con
   `margin-left: calc(-1 * var(--f7-popup-tablet-width)/2)`, así que un `max-width` encoge la caja
   y la deja descentrada en pantalla ancha.
   Y el tope se pone con un `@media` y no con `min()`, que no existe en los navegadores del
   browserslist del proyecto (Chrome 49, Firefox 31, iOS 11): la variable aceptaría el texto
   igualmente —una propiedad personalizada se guarda sin validar—, pero al sustituirla en el `width`
   y en el `margin-left` las dos declaraciones quedarían inválidas y el aviso perdería ancho y
   centrado en tablet. Es el mismo remedio que el popup de persona del control de cifras OEB
   (`control-cifras-oeb-planificacion.vue`). 820px es el 80% de 1025px, así que el corte cae justo
   donde el tope empezaba a morder. */
.popup-planif-abiertas {
  --f7-popup-tablet-width: 80%;
}
@media (min-width: 1025px) {
  .popup-planif-abiertas {
    --f7-popup-tablet-width: 820px;
  }
}
.pa-intro p {
  margin: 0 0 8px 0;
}
.pa-nota {
  font-style: italic;
  color: #555;
}
.pa-fila-titulo {
  font-weight: bold;
}
.pa-estado {
  color: #8a6414;
}
.pa-acciones {
  margin-top: 4px;
  white-space: normal;
}
.pa-sin-acceso {
  color: #555;
  white-space: normal;
}
/* La separación va por margen y no por `gap`: el `gap` de flex tampoco existe en los navegadores
   del browserslist (Chrome 49, iOS 11) y ahí los dos botones de salida saldrían pegados, que en una
   pantalla donde uno cancela el pedido y el otro no es justo donde no conviene. */
.pa-salidas {
  display: flex;
  flex-direction: column;
}
.pa-salidas > * + * {
  margin-top: 8px;
}
/* Framework7 declara `button { width: 100% }` sobre el selector de tipo, y el navegador les da
   `text-align: center`: sin estas tres líneas el botón de «ir al calendario» sale como una caja del
   ancho de la fila con el texto en el medio, lejos de la planificación que anuncia. No es
   decoración. */
.pa-boton-ir {
  display: inline-block;
  width: auto;
  min-width: 0;
  text-align: left;
}
/* El `:focus` a secas vale en todos los navegadores; el par siguiente retira el recuadro solo al
   pulsar con el ratón y solo donde el navegador sabe distinguirlo. Si no entiende
   `:focus-visible`, descarta el par y se queda el recuadro siempre, que es el lado seguro. */
.pa-boton-ir:focus {
  outline: 2px solid #1c3e6e;
  outline-offset: 2px;
}
.pa-boton-ir:focus:not(:focus-visible) {
  outline: none;
}
.pa-boton-ir:focus-visible {
  outline: 2px solid #1c3e6e;
  outline-offset: 2px;
}
.pa-explicacion-bloqueo {
  color: #555;
  font-size: 13px;
}
</style>

<script>
import moment from "moment";
import { puedeAbrirCalendario, rutaCalendario } from "./../../calendario/permisos.js";
import {
  LIMITE_MOTIVO_SALIDA,
  normalizarMotivoSalida
} from "./../../../js/utils/motivoSalidaPedido.js";

/**
 * #425 · El aviso que se interpone al cancelar, desactivar o eliminar un pedido que todavía tiene
 * planificaciones abiertas (PLANIFICADAS, o REALIZADAS cuya línea aún no tiene TPC).
 *
 * Las tres salidas que ofrece son las de la incidencia: ir al calendario a desplanificar (por el
 * flujo de siempre, sin tocar nada desde aquí), continuar igualmente con un motivo, o dejar el
 * pedido como está.
 */
export default {
  props: {
    opened: { type: Boolean, default: false },
    /** 'CANCELAR' | 'DESACTIVAR' | 'CANCELAR_Y_DESACTIVAR' | 'ELIMINAR' */
    accion: { type: String, default: "CANCELAR" },
    codigoPedido: { type: String, default: "" },
    planificaciones: { type: Array, default: () => [] }
  },
  data() {
    return {
      motivo: ""
    };
  },
  computed: {
    textoAccion() {
      return {
        CANCELAR: "cancelar",
        DESACTIVAR: "desactivar",
        CANCELAR_Y_DESACTIVAR: "cancelar y desactivar",
        ELIMINAR: "eliminar"
      }[this.accion] || "cancelar";
    },
    motivoValido() {
      return !!this.motivo && !!this.motivo.trim();
    },
    limiteMotivo() {
      return LIMITE_MOTIVO_SALIDA;
    },
    /**
     * El tope se dice junto al campo y mientras se escribe, no cuando ya no deja teclear: un campo
     * que de pronto deja de responder parece roto (misma razón que la §9 del CLAUDE.md).
     *
     * Y lo dice sobre lo que de verdad va a viajar, no sobre la cuenta de caracteres: el tope del
     * borrado es también el tamaño del texto dentro de la URL, y con un alfabeto que
     * `encodeURIComponent` engorda mucho ese tope llega antes que el de 300 (ver
     * `motivoSalidaPedido.js`). El campo no puede decir «quedan 150» mientras lo que se manda ya
     * va recortado: serían las dos mitades de la misma pantalla diciendo lo contrario.
     */
    infoMotivo() {
      const escrito = this.motivo || "";
      if (normalizarMotivoSalida(escrito).length < escrito.trim().length) {
        return "Has llegado al tope: lo que escribas de más no se guarda.";
      }
      const restantes = this.limiteMotivo - escrito.length;
      return restantes > 0
        ? "Quedan " + restantes + " caracteres de " + this.limiteMotivo + "."
        : "Has llegado al tope de " + this.limiteMotivo + " caracteres: lo que escribas de más no se guarda.";
    }
  },
  watch: {
    // El motivo no se arrastra de una vez a la siguiente: lo que se anota en el histórico tiene que
    // ser lo que esta persona ha escrito para ESTA cancelación.
    opened(abierto) {
      if (abierto) {
        this.motivo = "";
      }
    }
  },
  methods: {
    puedeAbrirCalendario,
    personasDe(planificacion) {
      return (planificacion && planificacion.personas) || [];
    },
    nombrarPersonas(planificacion) {
      const personas = this.personasDe(planificacion);
      if (!personas.length) {
        return "Sin inspector asignado";
      }
      return personas.map(p => p.nombre || p.username).join(", ");
    },
    formatearFecha(fecha) {
      if (!fecha) {
        return "Sin fecha";
      }
      return moment(fecha).format("DD/MM/YYYY HH:mm");
    },
    textoEstado(planificacion) {
      return planificacion.motivo === "REALIZADA_SIN_TPC"
        ? "Realizada, pero su línea todavía no tiene TPC"
        : "Planificada";
    },
    /**
     * Abre el calendario de esa persona, posicionado en el día de la planificación.
     *
     * En el navegador, en pestaña nueva, que es además como la aplicación abre ya el calendario de
     * otra persona (`calendario.vue`, `open()`): así el pedido se queda tal cual en esta pestaña,
     * con su aviso, y al volver de desplanificar se puede reintentar sin rehacer nada.
     *
     * **En la aplicación empaquetada (`TARGET=cordova`) no hay pestañas**, y un
     * `window.open(..., "_blank")` de una ruta interna no abre nada: el proyecto no lleva el plugin
     * InAppBrowser. O sea, el botón se quedaría muerto y dejaría a la persona sin la única vía de
     * corregir la planificación, que es justo lo que el aviso existe para ofrecer. Ahí se navega
     * con el router de Framework7, exactamente como hace `open()` de `calendario.vue`, que distingue
     * los dos casos por este mismo `target`.
     *
     * Antes de navegar se cierra el aviso —si no, el popup se queda tapando el calendario al que
     * acabamos de ir—, y cerrarlo deja el pedido sin guardar, que es lo que corresponde mientras la
     * planificación siga abierta: al volver con el botón de atrás, la ficha está igual y se puede
     * reintentar. En el navegador el aviso NO se cierra, porque la pestaña del pedido no se mueve.
     *
     * Esa cancelación va marcada `silencioso`: irse al calendario no es echarse atrás, es la salida
     * que el aviso ofrece. Sin la marca, la ficha la contaba como «no cancelar el pedido» y soltaba
     * un «No se ha guardado nada…» que aterrizaba encima del calendario, tapando justo la pantalla
     * a la que acabábamos de llevar a la persona.
     */
    irAlCalendario(username, fecha) {
      const url = rutaCalendario(username)
        + (fecha ? "?fecha=" + moment(fecha).format("YYYY-MM-DD") : "");
      if (process.env.TARGET === "cordova") {
        this.$emit("ir-al-calendario", { username: username, url: url });
        this.$emit("cancelar", { silencioso: true });
        this.$nextTick(() => this.navegarEnApp(url));
        return;
      }
      window.open("#!" + url, "_blank");
      this.$emit("ir-al-calendario", { username: username, url: url });
    },
    /**
     * La navegación interna de la aplicación empaquetada. Si no hubiera vista con router —no
     * debería pasar, pero este botón es la única salida útil del aviso— se cae al `window.open`
     * de siempre antes que no hacer nada.
     */
    navegarEnApp(url) {
      const app = this.$f7;
      const vista = app && app.views ? app.views.current : null;
      if (vista && vista.router) {
        vista.router.navigate({ url: url, ignoreCache: true });
        return;
      }
      window.open("#!" + url, "_blank");
    },
    continuar() {
      if (!this.motivoValido) {
        return;
      }
      this.$emit("continuar", { confirmado: true, motivo: normalizarMotivoSalida(this.motivo) });
    }
  }
};
</script>
